/* eslint-disable jsx-a11y/no-static-element-interactions */

import { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import '../assets/css/RideModal.css'

export default function RideCart({ ride, mobile = false }) {
    const [showMore, setShowMore] = useState(false);
    const [show, setShow] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        if (textRef.current) {
            const el = textRef.current;
            // check if text overflows 3 lines
            if (el.scrollHeight > el.clientHeight + 1) {
                setShowMore(true);
            }
        }
    }, [ride.description]);

    return <>
        {
            mobile && <div key={ride.id} className="info-box" onClick={() => setShow(true)}>
                <div className="left-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                        <circle cx="2" cy="2" r="2" fill="#3F3F3F" />
                    </svg>
                </div>
                <p>{ride.name}</p>
            </div>
        }

        {
            !mobile && <div key={ride.id} className="col-md-4 col-sm-6 ride-cart">
                <div className="card h-100">
                    <div className="park-img-container">
                        <img
                            src={ride.logo}
                            className="card-img-top"
                            alt={ride.name}
                        />
                    </div>
                    <div className="card-body">
                        <div>
                            <h5 className="card-title">{ride.name}</h5>
                            <p className="card-text" data-lines="3" ref={textRef}>
                                {ride.description}
                            </p>
                            {showMore && <button type="button" className="card-more" data-lines="3" ref={textRef} onClick={() => setShow(true)}>
                                More
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        }

        <Modal
            show={show}
            onHide={() => setShow(false)}
            dialogClassName="ride-info-modal modal-90w"
            aria-labelledby="example-ride-info-modal-styling-title"
        >
            <Modal.Header className="ride-details-header" closeButton>
                <Modal.Title className="ride-details-name" id="example-ride-info-modal-styling-title">
                    {ride.name}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="ride-info-modal-body">
                <img
                    src={ride.logo}
                    alt={ride.name}
                    className="ride-image"
                />
                <h6 className="ride-details-title">Details</h6>
                <p className="ride-description">{ride.description || 'None'}</p>
            </Modal.Body>
        </Modal>

    </>
}
